import React, { useState } from 'react';
import { IconCopy, IconCheck } from './Icons.jsx';

export function CopyButton({ text, label = 'Copy', compact = false, iconOnly = false, title }) {
  const [copied, setCopied] = useState(false);
  const onCopy = (e) => {
    e.stopPropagation();
    try { navigator.clipboard?.writeText(text); } catch (_) {}
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  };
  const cls = `btn btn-ghost ${compact || iconOnly ? 'btn-sm' : ''} ${iconOnly ? 'icon-only' : ''}`.trim();
  return (
    <button onClick={onCopy} className={cls} title={title || (copied ? 'Copied' : label)}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {copied ? <IconCheck size={14} stroke="var(--success-600)"/> : <IconCopy size={14}/>}
      {!compact && !iconOnly && (copied ? 'Copied' : label)}
    </button>
  );
}
